import { render, staticRenderFns } from "./UserDetailView.vue?vue&type=template&id=9a583800&scoped=true&"
import script from "./UserDetailView.vue?vue&type=script&lang=js&"
export * from "./UserDetailView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=9a583800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a583800",
  null
  
)

export default component.exports